import PropTypes from 'prop-types';

export const SYSTEM_DATA_THEMES = {
  LIGHT: 'light',
  DARK: 'dark',
};

export const FLOATING_PLACEMENTS = {
  TOP_START: 'top-start',
  TOP: 'top',
  TOP_END: 'top-end',
  RIGHT_START: 'right-start',
  RIGHT: 'right',
  RIGHT_END: 'right-end',
  BOTTOM_START: 'bottom-start',
  BOTTOM: 'bottom',
  BOTTOM_END: 'bottom-end',
  LEFT_START: 'left-start',
  LEFT: 'left',
  LEFT_END: 'left-end',
};

export const TOOLTIP_MODEL = PropTypes.shape({
  dataTheme: PropTypes.oneOf(Object.values(SYSTEM_DATA_THEMES)),
  text: PropTypes.string,
  placement: PropTypes.oneOf(Object.values(FLOATING_PLACEMENTS)),
  maxWidth: PropTypes.string,
  offset: PropTypes.number,
  openDelay: PropTypes.number,
  closeDelay: PropTypes.number,
  className: PropTypes.string,
});
